import React from 'react';
import '.././styles/Loader.scss'

function Loader() {
    return (
        <div className="loader">
            <img
                src="https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/loader.svg"
                alt="loading background"
                className="loaderBg"
            />

            <img
                src="https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/search.svg"
                alt="search icon"
                className="loaderSearchIcon"
            />
        </div>
    )
}

export default Loader